export const ANNOUNCEMENTS_ROOT_URL: string | undefined = process.env.ANNOUNCEMENTS_ROOT_URL;
